import { SessionDialog } from "../dialogs/session-dialog";
import { C } from "../messages/methods/constants";
import { OutgoingInfoRequest } from "../messages/methods/info";
import { OutgoingRequestDelegate, RequestOptions } from "../messages/outgoing-request";
import { NonInviteClientTransaction } from "../transactions/non-invite-client-transaction";
import { UserAgentClient } from "./user-agent-client";

/**
 * INFO UAC.
 * @public
 */
export class InfoUserAgentClient extends UserAgentClient implements OutgoingInfoRequest {
  constructor(dialog: SessionDialog, delegate?: OutgoingRequestDelegate, options?: RequestOptions) {
    const message = dialog.createOutgoingRequestMessage(C.INFO, options);
    super(NonInviteClientTransaction, dialog.userAgentCore, message, delegate);
  }
}
